module.exports = __webpack_public_path__ + "img/xh.472e701b.png";